import {useEffect} from "react";

export default function Message(props) {
    let color = props.data.isSuccess ? 'success_message' : 'warn_message';
    let show = props.data.show ? 'd-block' : 'd-none';

    useEffect(() => {
        if (props.data.show === true) {
            let timeout = setTimeout(props.handler, 4000);

            return () => {
                clearTimeout(timeout);
            };
        }
    }, [props.data.show]);

    return (
        <div className={`toast ${show} absolute-center ${color}`} role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header">
                <strong className="me-auto">{props.data.header}</strong>
                <small>{props.data.headerSmall}</small>
                <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Закрыть" onClick={props.closeHandler}></button>
            </div>
            <div className="toast-body">
                {props.data.text}
            </div>
        </div>
    )
}